import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/api.service';
import { Observable, map } from 'rxjs';
import { Tipologia } from 'app/modules/models/tipologia.model';
import { UsuarioModel } from './models/usuario-form.model';
import { ResponseInterface } from 'app/modules/models/response.model';

@Injectable({ providedIn: 'root' })
export class UsuariosService {
    constructor(private api: ApiService) {}

    getTipologias(tipologiaId:number) {
        const url = `/tipologias/${tipologiaId}`
        return new Promise((resolve, reject) => {
            this.api.GetMethod(url, {}, 'Error al obtener datos')
                .subscribe( (users: Tipologia[]) => {
                    resolve( users)
                }, error => reject(error))
        })
    }

    crearUsuario(usuario: UsuarioModel){
        const url = `/usuarios/signup`;
        return new Promise((resolve, reject) => {
            this.api.PostMethod(url, usuario, {}, 'Error al agregar usuario')
                .subscribe(response => resolve(response), error => reject(error));
        });
    }

    getUsuarios(){
        const url = `/usuarios`
        return new Promise((resolve, reject) => {
            this.api.GetMethod(url, {}, 'Error al obtener usuarios')
                .subscribe( (response:{total:number, data: UsuarioModel[]}) => {
                    resolve( response.data)
                }, error => reject(error))
        })
    }

    actualizarUsuario(usuarioId:number, params:any): Promise<ResponseInterface> {
        const url = `/usuarios/${usuarioId}`
        return new Promise((resolve, reject) => {
            this.api.PutMethod(url, {}, params, 'Error al actualizar usuarios')
                .subscribe( (response: ResponseInterface) => {
                    resolve(response);
                }, error => reject(error))
        })
    }
}
